import { render, staticRenderFns } from "./PreviewCertificateTH.vue?vue&type=template&id=6921b10e"
import script from "./PreviewCertificateTH.vue?vue&type=script&lang=js"
export * from "./PreviewCertificateTH.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports